import { Injectable } from "@angular/core";
import { FileSnapshot } from "../models";


@Injectable({
    providedIn: 'root'
})
export class SignatoryService {
 
    public getUrl(file: FileSnapshot, signFile?: (fileKey: string) => void): string {
        if(!file) {
            return null;
        }

        if(!file.signatureRequired) {
            return file.uri;
        }

        if(file.signature != null && new Date(file.signature.expiration) > new Date()) {
            return `${file.uri}${file.signature.value}`;
        }

        if(!signFile) {
            return null;
        }

        signFile(file.key);
    }

}